import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getImportJobs(params) {
  const response = await axiosClient.get(`/admin/product-imports${toQueryString(params)}`);
  return response.data;
}

export async function getImportJob(id) {
  const response = await axiosClient.get(`/admin/product-imports/${id}`);
  return response.data;
}

export async function startImportJob({ storeId, sourceUrl, isCollection }) {
  const response = await axiosClient.post("/admin/product-imports", { storeId, sourceUrl, isCollection });
  return response.data;
}

export async function updateImportItem(jobId, itemId, patch) {
  const response = await axiosClient.patch(`/admin/product-imports/${jobId}/items/${itemId}`, patch);
  return response.data;
}

export async function updateImportItemVariant(jobId, itemId, variantId, patch) {
  const response = await axiosClient.patch(`/admin/product-imports/${jobId}/items/${itemId}/variants/${variantId}`, patch);
  return response.data;
}

export async function approveImportItem(jobId, itemId) {
  const response = await axiosClient.post(`/admin/product-imports/${jobId}/items/${itemId}/approve`);
  return response.data;
}

export async function approveImportItemsBulk(jobId, itemIds) {
  const response = await axiosClient.post(`/admin/product-imports/${jobId}/items/approve-bulk`, { itemIds });
  return response.data;
}

export async function rejectImportItem(jobId, itemId) {
  const response = await axiosClient.post(`/admin/product-imports/${jobId}/items/${itemId}/reject`);
  return response.data;
}

export async function deleteImportJob(id) {
  const response = await axiosClient.delete(`/admin/product-imports/${id}`);
  return response.data;
}
